import Companies from './Companies.component';

export default Companies;
